<button *ngIf="token" ngxPlaidLink
  [env]="plaid.env"
  [publicKey]="plaid.publicKey"
  [clientName]="plaid.clientName"
  [selectAccount]="plaid.selectAccount"
  [token]="token"
  (Success)="onPlaidSuccess($event)"
  (Exit)="onPlaidExit($event)"
  (Load)="onPlaidLoad($event)"
  (Event)="onPlaidEvent($event)"
  (Click)="onPlaidClick($event)"
  class="action-button btn btn--paybee btn--purple w-100"
> Bank Login </button>
